// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__qqpU6","approved":"Status_approved__BJQSz","rejected":"Status_rejected__1Tcbk","expired":"Status_expired__2KOU1","label":"Status_label__2kSGa"};